
import React from 'react';
import { CloseIcon, ArticleIcon } from './icons';

interface ArticleTypeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (type: 'Press Release' | 'Strategic Pillars' | 'Programmes') => void;
}

const Modal: React.FC<{ isOpen: boolean; onClose: () => void; children: React.ReactNode }> = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex justify-center items-center p-4" onClick={onClose} role="dialog" aria-modal="true">
            <div className="bg-white rounded-2xl shadow-lg w-full max-w-2xl" onClick={(e) => e.stopPropagation()}>
                {children}
            </div>
        </div>
    );
};

const ArticleTypeModal: React.FC<ArticleTypeModalProps> = ({ isOpen, onClose, onSelect }) => {
  const articleTypes = [
    { name: 'Press Release', icon: <ArticleIcon className="w-6 h-6 text-green-500" /> },
    { name: 'Strategic Pillars', icon: <ArticleIcon className="w-6 h-6 text-green-500" /> },
    { name: 'Programmes', icon: <ArticleIcon className="w-6 h-6 text-green-500" /> },
  ];

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-gray-800">Articles Type</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-800" aria-label="Close modal">
            <CloseIcon className="w-6 h-6" />
          </button>
        </div>
        <p className="text-sm text-gray-500 mb-6">Select an article type to create</p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {articleTypes.map((type) => (
            <button
              key={type.name}
              onClick={() => onSelect(type.name as 'Press Release' | 'Strategic Pillars' | 'Programmes')}
              className="flex flex-col items-center justify-center text-center p-6 bg-gray-50 rounded-lg border border-gray-200 hover:bg-gray-200/20 hover:border-gray-300 transition-colors"
            >
              <div className="bg-green-100 p-3 rounded-full mb-3">
                {type.icon}
              </div>
              <span className="text-sm font-semibold text-gray-700">{type.name}</span>
            </button>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default ArticleTypeModal;
